
const state = {
  // 登录账号的所在机构类型 1：腾慧  2：珊瑚
  isShanhu: localStorage.getItem('tengface_is_shanhu') || 2,
	org_id: localStorage.getItem('tengface_org_id') || "",
  fans_id:localStorage.getItem('tengface_fans_id') || "",
  mofang_url: localStorage.getItem('tengface_mofang_url') || "",
  isCheckToken:false,
  unreadCount:localStorage.getItem('unreadCount') ||0,
  remark:localStorage.getItem('tengface_remark') || "",
  orgDomain: localStorage.getItem('tengface_org_domain') || '',
  licenseUrl: "https://license.vod2.myqcloud.com/license/v2/1317978474_1/v_cube.license"
}

const getters = {
  getRemark(state){
    return state.remark
  },
  getOrgId(state){
    return state.org_id
  },
  getFansId(state){
		return state.fans_id
	},
  getMoFangUrl(state) {
    return state.mofang_url
  },
  getIScheckToken(state) {
    return state.isCheckToken
  },
  getUnreadCount(state) {
    return state.unreadCount
  },
  getDomain(state) {
    return state.orgDomain
  },
  getIsShanhuState(state) {
    try {
        return Number(state.isShanhu) === 2
    } catch (error) {
        return false
    }
  },
  getLicenseUrl(state) {
    return state.licenseUrl
  }
}

const actions = {
   
}

const mutations = {
  setUnreadCount(state, data) {
    state.unreadCount = data
  },
   setOrgId(state, data) {
     state.org_id = data
   },
   setFansId(state, data) {
     state.fans_id = data
     localStorage.setItem('tengface_fans_id', data)
   },
   setMoFangUrl(state, data) {
    state.mofang_url = data
  },
  setIScheckToken(state, data) {
    state.isCheckToken = data
  },
  setRemark(state,data){
    state.remark=data
    localStorage.setItem('tengface_remark',data)
  },
  setOrgDoamin(state,data) {
    state.orgDomain = data
    localStorage.setItem('tengface_org_domain', data)
  },
  setIsShanhuState(state, data){
    state.isShanhu = data
  },
  setLicenseUrl(state, data) {
    state.licenseUrl = data
  }
}

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
}
